import "./styles.scss";
import { Icons } from "../../asset/IconSun";

export const Spinner = () => {
  return (
    <div className="spinner">
      <Icons type='spinner'/>
    </div>
  );
};